import NextImage from "next/legacy/image";

function Image({ src, ...props }) {
  if (src[0] === "/") src = process.env.NEXT_PUBLIC_BASE_URL + src;
  return <NextImage src={src} {...props} />;
}

export default Image;
